export default __webpack_public_path__ + "static/media/play-store-badge.0452f7a5.svg";